import React from 'react';
import './ConfirmationModal.css';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';

interface Props {
  message: React.ReactNode;
  header: string;
  handleConfirm: () => Promise<void> | void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  confirmButtonDisabled?: boolean;
}
const ConfirmationModal = ({
  message,
  header,
  showModal,
  setShowModal,
  handleConfirm,
  confirmButtonDisabled = false,
}: Props) => {
  const { t } = useTranslation();

  const handleSubmit = async () => {
    await handleConfirm();
    handleClose();
  };
  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <Modal
      titleText={header}
      submitButtonText={t('common.button.ok')}
      show={showModal}
      submitButtonDisabled={confirmButtonDisabled}
      onClose={handleClose}
      onSubmit={handleSubmit}
    >
      <div className="confirmation-body">{message}</div>
    </Modal>
  );
};

export default ConfirmationModal;
